import { gql } from '@grandvisionhq/graphql';
import { checkoutMutationResult } from '../fragments/checkout-mutation-result.js';
import { shipmentMethodDoesNotMatchCartFailure, unknownUpdateCartFailure, shipmentMethodNotFoundFailure } from '../fragments/cart-mutation-failures.js';

const SET_SHIPPING_METHOD = gql`
  mutation SetShippingMethod($shippingMethodInput: ShippingMethodInput!) {
    setShippingMethod(shippingMethodInput: $shippingMethodInput) {
      ...CheckoutMutationResultFragment
      failures {
        ...ShipmentMethodNotFoundFailureFragment
        ...ShipmentMethodDoesNotMatchCartFailureFragment
        ...UnknownUpdateCartFailureFragment
      }
    }
  }
  ${checkoutMutationResult}
  ${shipmentMethodDoesNotMatchCartFailure}
  ${unknownUpdateCartFailure}
  ${shipmentMethodNotFoundFailure}
`;

export { SET_SHIPPING_METHOD };
//# sourceMappingURL=set-shipping-method.js.map
